import { Button } from '@/components/ui/button';
import { RateOffsetTable, useRateOffsetLogs } from 'features/rate-offset-log';

import type { RateOffsetLog } from 'graphql/gql-types';
import { useState } from 'react';

export const Main = () => {
	const [page, setPage] = useState(0);
	const { data, loading } = useRateOffsetLogs(page);
	const dataLength = data?.getHotelRateOffsetLogs?.length;

	const handlePaging = (pageChangeNumber: number) => {
		setPage((prevState) =>
			prevState + pageChangeNumber > -1
				? prevState + pageChangeNumber
				: prevState,
		);
	};

	return (
		<div>
			<h1>Rate Offset Log</h1>
			{loading && <div>Loading...</div>}

			{data && !loading && (
				<>
					<RateOffsetTable
						data={data?.getHotelRateOffsetLogs as RateOffsetLog[]}
					/>
					<div className='form-buttons'>
						<div className='left'>
							<Button
								type='button'
								onClick={() => handlePaging(-1)}
								disabled={page <= 0}
								className='back'
							>
								Previous
							</Button>
						</div>
						<div className='right'>
							<Button
								type='button'
								onClick={() => handlePaging(1)}
								disabled={!!dataLength && dataLength < 8}
							>
								Next
							</Button>
						</div>
					</div>
				</>
			)}
			{!data && !loading && <div>No data found</div>}
		</div>
	);
};
